import 'es6-promise/auto';
import Vue from 'vue';
import Vuex, {Payload, Store} from 'vuex';
import VuexPersistence from 'vuex-persist';
import mutations from './mutations';
import actions from './actions';
import { initialStateGlobalSettings } from './state';
Vue.use(Vuex);

// ============Vuex Persistence object start===========
const vuexLocal = new VuexPersistence({
    key: 'sef',
    storage: window.localStorage,
    reducer: state => ({
        user: state.user,
        idleTime: state.idleTime
    })
})
// ============Vuex Persistence object end===========

//=======vuex store start===========
const store = new Vuex.Store({
    state: initialStateGlobalSettings,
    mutations ,
    actions,
    plugins: [vuexLocal.plugin],
    getters: {
        getUserFullName: state => {
            return state.user.fullName;
        },
        getUserEmail: state => {
            return state.user.email;
        },
        getIdleTime: state => {
            return state.idleTime;
        },
        isLoggedIn: state => {
            return state.adminLoggingIn;
        },
        idIdleLogout: state => {
            return state.idleLogout;
        },
        getResetToken: state => {
            return state.resetToken;
        },
        getResetUserId: state => {
            return state.resetUserId;
        },
        getLogoutState: state => {
            return state.logoutState;
        },
    }
});
//=======vuex store end===========
export default store
